import { render, staticRenderFns } from "./PorezBase.vue?vue&type=template&id=5ccc79d6&scoped=true&"
import script from "./PorezBase.vue?vue&type=script&lang=js&"
export * from "./PorezBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc79d6",
  null
  
)

export default component.exports